import React from "react";
import "./Loader.scss";

interface LoaderProps {
  visible: boolean;
}

export function Loader({ visible }: LoaderProps) {
  if (!visible) return null;

  return (
    <div className="general-loader-overlay" aria-hidden={!visible}>
      <div className="general-loader-container">
        <div className="lotus-loader-wrapper">
          <svg
            width="200"
            height="200"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="lotus-petal lotus-petal-left"
              d="M2.31668 25.7461C5.72759 33.0585 12.2671 37.9134 19.598 39.4592C23.1246 32.8502 23.6106 24.7187 20.1997 17.4063C16.7887 10.0939 10.2492 5.239 2.91833 3.69321C-0.608281 10.3021 -1.09423 18.4337 2.31668 25.7461Z"
              fill="#DC64A0"
            />
            <path
              className="lotus-petal lotus-petal-center"
              d="M9.73096 19.7296C9.73096 27.7964 13.6047 34.9607 19.5981 39.4592C25.5868 34.9607 29.4652 27.7964 29.4652 19.7296C29.4652 11.6628 25.5915 4.49851 19.5981 0C13.6093 4.49851 9.73096 11.6628 9.73096 19.7296Z"
              fill="#7A0079"
            />
            <path
              className="lotus-petal lotus-petal-right"
              d="M18.9964 17.4063C15.5855 24.7187 16.0714 32.8502 19.598 39.4592C26.9289 37.9134 33.4684 33.0585 36.8793 25.7461C40.2902 18.4337 39.8043 10.3021 36.2777 3.69321C28.9468 5.239 22.4073 10.0939 18.9964 17.4063Z"
              fill="#F2138E"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}

export default Loader;